import { render, staticRenderFns } from "./goveEmm.vue?vue&type=template&id=426528a6&scoped=true"
import script from "./goveEmm.vue?vue&type=script&lang=js"
export * from "./goveEmm.vue?vue&type=script&lang=js"
import style0 from "./goveEmm.vue?vue&type=style&index=0&id=426528a6&prod&lang=less&scoped=true"
import style1 from "./goveEmm.vue?vue&type=style&index=1&id=426528a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426528a6",
  null
  
)

export default component.exports